function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import { Steps } from "antd";
const {
  Step
} = Steps;
/**
 * 步驟條
 */

const StepBar = ({
  current = 0,
  steps = []
}) => {
  return /*#__PURE__*/React.createElement(Steps, {
    current: current
  }, steps.map((step, index) => {
    return /*#__PURE__*/React.createElement(Step, _extends({
      key: index
    }, step));
  }));
};

export default StepBar;
StepBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    subTitle: PropTypes.string
  })),
  current: PropTypes.number
};